/**
 * <p>****************************************************************************</p>
 * <p><b>Copyright © 2010-2019 soho team All Rights Reserved<b></p>
 * <ul style="margin:15px;">
 * <li>Description : 凭证模板</li>
 * <li>Version     : 1.0</li>
 * <li>Creation    : 2019年08月01日</li>
 * <li>@author     : ____′↘夏悸</li>
 * </ul>
 * <p>****************************************************************************</p>
 */
import Ajax from '../js/common/ajax';

export default {
	list(params) {
		return Ajax.get("/voucher-template", params)
	},
	load(id) {
		return Ajax.get(`/voucher-template/${id}`)
	},
	delete(id) {
		return Ajax.delete(`/voucher-template/${id}`)
	},
	save(params = {}) {
		return Ajax.post(`/voucher-template`, params)
	},
	update(params = {}) {
		return Ajax.put(`/voucher-template`, params)
	}
}
